const formatDate = (date: any): string => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
};
const formatDateWithDot = (date: any): string => {
    if (!date || Number.isNaN(new Date(date).getTime()) || new Date(date).getFullYear() === 1970) {
        return '';
    }
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('.');
};
const formatDateHour = (date: any): string => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    let hour = '' + d.getHours();
    let min = '' + d.getMinutes();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (min.length < 2) min = '0' + min;

    return [day, month, year].join('-') + ' ' + hour + ':' + min;
};
const formatDateHourSecond = (date: any): string => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        min = '' + d.getMinutes(),
        second = '' + d.getSeconds();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (min.length < 2) min = '0' + min;
    if (second.length < 2) second = '0' + second;

    return [day, month, year].join('-') + ' ' + hour + ':' + min + ':' + second;
};
const formatDateDesc = (date: any): string => {
    let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
};
function reverseDateFormat(inputDate: any) {
    // Girilen stringi parçala
    const year = inputDate.substring(0, 4);
    const month = inputDate.substring(4, 6);
    const day = inputDate.substring(6, 8);

    // Yıl, ay ve gün bilgilerini birleştirerek tersine çevrilmiş formata dönüştür
    const reversedFormat = `${day}.${month}.${year}`;

    return reversedFormat;
}

const formatToTurkishDateTime = (isoDate: string): string => {
    const date = new Date(isoDate);

    const options: Intl.DateTimeFormatOptions = {
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };

    const formatter = new Intl.DateTimeFormat('tr-TR', options);
    const parts = formatter.formatToParts(date);

    const day = parts.find((p) => p.type === 'day')?.value;
    const month = parts.find((p) => p.type === 'month')?.value;
    const year = parts.find((p) => p.type === 'year')?.value;
    const hour = parts.find((p) => p.type === 'hour')?.value;
    const minute = parts.find((p) => p.type === 'minute')?.value;

    return `${day}-${month}-${year} ${hour}:${minute}`;
};

// Date format configurations for different cultures
const dateFormatConfigs: Record<string, (date: Date) => string> = {
    'tr-TR': (date: Date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hour}:${minute}`;
    },
    'en-US': (date: Date) => {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        return `${month}/${day}/${year} ${hour}:${minute}`;
    },
    default: (date: Date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hour}:${minute}`;
    },
};

const formatDateHourWithTimezone = (dateString: any, cultureCode?: string): string => {
    if (!dateString) return '';

    try {
        // Parse ISO 8601 format with timezone offset
        // Expected format: 2025-10-21T09:40:11.443768+03:00
        const isoRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?([+-]\d{2}:\d{2}|Z)?$/;
        const match = dateString.match(isoRegex);

        if (match) {
            const [, year, month, day, hour, minute, second, timezoneOffset] = match;

            // Create UTC date
            const utcDate = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);

            // Parse timezone offset and add to UTC time
            if (timezoneOffset && timezoneOffset !== 'Z') {
                const offsetRegex = /([+-])(\d{2}):(\d{2})/;
                const offsetMatch = timezoneOffset.match(offsetRegex);

                if (offsetMatch) {
                    const [, sign, offsetHours, offsetMinutes] = offsetMatch;
                    const totalOffsetMinutes =
                        (Number.parseInt(offsetHours) * 60 + Number.parseInt(offsetMinutes)) * (sign === '+' ? 1 : -1);

                    // Add offset to UTC time to get local time
                    utcDate.setMinutes(utcDate.getMinutes() + totalOffsetMinutes);
                }
            }

            // Get culture code from localStorage if not provided
            const culture = cultureCode || localStorage.getItem('i18nextLng') || 'tr-TR';

            // Get format function for culture or use default
            const formatFunc = dateFormatConfigs[culture] || dateFormatConfigs['default'];

            return formatFunc(utcDate);
        }

        // Fallback to standard date parsing if format doesn't match
        const d = new Date(dateString);
        const culture = cultureCode || localStorage.getItem('i18nextLng') || 'tr-TR';
        const formatFunc = dateFormatConfigs[culture] || dateFormatConfigs['default'];

        return formatFunc(d);
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};

// Açıklama:
//const date = "2025-10-21T09:40:11.443768+03:00";

// tr-TR formatı (varsayılan)
//TimeHelper.formatDateHourWithTimezone(date)
// Output: "21.10.2025 12:40"

// en-US formatı
//TimeHelper.formatDateHourWithTimezone(date, 'en-US')
// Output: "10/21/2025 12:40"

// Default format
//TimeHelper.formatDateHourWithTimezone(date, 'de-DE')
// Output: "2025-10-21 12:40" (tanımsız culture için default kullanılır)

/**
 * Calculate date range for quick date selection options
 * @param type - Type of date range: 'today' | 'thisWeek' | 'lastWeek' | 'thisMonth' | 'lastMonth'
 * @returns Object with startDate and endDate in YYYY-MM-DD format
 */
const getQuickDateRange = (
    type: 'today' | 'thisWeek' | 'lastWeek' | 'thisMonth' | 'lastMonth'
): { startDate: string; endDate: string } => {
    const today = new Date();
    let start: Date;
    let end: Date;

    const format = (date: Date) => {
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    switch (type) {
        case 'today':
            start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            end = new Date(start);
            break;
        case 'thisWeek': {
            const dayOfWeek = today.getDay(); // 0 (Sun) - 6 (Sat)
            const diffToMonday = (dayOfWeek + 6) % 7; // Monday as first day
            start = new Date(today);
            start.setDate(today.getDate() - diffToMonday);
            end = new Date(start);
            end.setDate(start.getDate() + 6);
            break;
        }
        case 'lastWeek': {
            const dayOfWeek = today.getDay();
            const diffToMonday = (dayOfWeek + 6) % 7;
            const thisMonday = new Date(today);
            thisMonday.setDate(today.getDate() - diffToMonday);
            start = new Date(thisMonday);
            start.setDate(thisMonday.getDate() - 7);
            end = new Date(start);
            end.setDate(start.getDate() + 6);
            break;
        }
        case 'thisMonth':
            start = new Date(today.getFullYear(), today.getMonth(), 1);
            end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
            break;
        case 'lastMonth':
            start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            end = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
        default:
            start = today;
            end = today;
    }

    return {
        startDate: format(start),
        endDate: format(end),
    };
};

const TimeHelper = {
    formatDate,
    formatDateHour,
    formatDateDesc,
    formatDateHourSecond,
    reverseDateFormat,
    formatDateWithDot,
    formatToTurkishDateTime,
    formatDateHourWithTimezone,
    getQuickDateRange,
};

export default TimeHelper;
